import React from 'react';

import Resources from '../Resources';

import { 
  fmtListAsCsv,
}                               from '../../components/utils/formatters';
  
function createColumnDefs() {
  const columnDefs = [
    { name: 'ResourceId', options: { display: true, filter: false } },
    { name: 'ClientAccountId', options: { display: false, filter: true } },
    { name: 'ResourceSubtype', label: 'Kind', options: { filter: true } },
    { name: 'TargetResourceSpec', label: 'Target', options: { filter: false } },
    { name: 'Description', options: { display: false, filter: true } },
    { name: 'SecurityConfiguration.Rotation', label: 'Rotation', options: { filter: true } },
    { name: 'SecurityConfiguration.SourceIPWhitelist', label: 'Whitelist', options: {
      filter: false,
      customBodyRender: fmtListAsCsv, 
    }},
    { name: 'ResourceType', options: { display: false, filter: false } },
    { name: 'StackUpdated', options: { display: true } },
  ];
  return columnDefs;
}

export default function Credentials(props) {

  const columnDefs = createColumnDefs();

  return (
    <Resources 
      type='Credential' 
      columnDefs={columnDefs} 
    />
  );
}

Credentials.propTypes = {
};

Credentials.defaultProps = {
};
